import { supabase } from '@/service/supabaseClient';

export namespace TimeSync {
  let offset = 0;
  let lastSync: Date | null = null;
  const resyncIntervalMs = 60 * 60 * 1000;

  export async function initialize() {
    await TimeSync.syncWithServer();
    // Risincronizza ogni ora
    setInterval(() => TimeSync.syncWithServer(), resyncIntervalMs);
  }

  export async function syncWithServer() {
    try {
      // step 1: timestamp locale prima della richiesta
      const t0 = Date.now();

      // chiamata RPC
      const { data, error } = await supabase.rpc('server_time');
      const t1 = Date.now(); // dopo la risposta

      if (error) throw error;

      const serverTime = new Date(data).getTime();
      const rtt = t1 - t0;
      const estimatedServerTimeNow = serverTime + rtt / 2; // stima: server time al momento 'ora locale'
      const offsetMs = estimatedServerTimeNow - t1; // server - client (positivo se server è avanti)
      offset = offsetMs;
      lastSync = new Date();
      console.log('Time sync successful', {
        serverTime,
        rtt,
        estimatedServerTimeNow,
        offsetMs,
        offset,
      });
    } catch (error) {
      console.warn('Time sync failed, using local time');
    }
  }

  export function now(): Date {
    return new Date(Date.now() + offset);
  }

  // Add these new exported functions at the end of the namespace (before the closing brace)
  /**
   * Gets the current time offset in milliseconds.
   * @returns {number} The offset value (positive if server time is ahead of client time).
   */
  export function getOffset(): number {
    return offset;
  }

  /**
   * Gets the timestamp of the last successful sync.
   * @returns {Date | null} The last sync date, or null if no sync has occurred.
   */
  export function getLastSync(): Date | null {
    return lastSync;
  }

  export function isRecent(timestamp: number, maxMinutes = 5): boolean {
    const timeDiff = (TimeSync.now().getTime() - new Date(timestamp).getTime()) / (1000 * 60);
    return timeDiff <= maxMinutes;
  }
}
